import {
  post_request,
  post_request_file
} from '../axiosFun'

//查询个人信息
export const get_user_one = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/person/get_userInfo", params)
}
//上传文件
export const get_user_upload = (params) => {
  params = {
    file: params.file,
    filename: params.filename,
    note: ""
  }
  return post_request_file("/common/upload", params)
}
//上传头像
export const get_user_upload_img = (params) => {
  params = {
    row: {
      imgUrl: params
    }
  }
  return post_request("/web/person/upload_img", params)
}
//修改信息
export const get_user_edit = (params) => {
    params = {
      row: {
        name:params.name,
        phone:params.phone,
        email:params.email
      }
    }
    return post_request("/web/person/edit", params)
  }
//修改密码
export const get_user_reset_password = (params) => {
  params = {
    row: {
      old_pwd:params.password,
      new_pwd:params.new_password,
    }
  }
  return post_request("/web/person/edit_password", params)
}



// WEBPACK FOOTER //
// ./src/api/user/user.js